var React = require('react');

function ChevronD (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.89,5.25l-2-2.62L0,0H7.79L5.84,2.63Z"}));
}

ChevronD.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 7.79 5.25"};

module.exports = ChevronD;

ChevronD.default = ChevronD;
